<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>TUTORIALS</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">
              <div class="pc-browser">Tutorial 总览</div>
              <div class="mobile-browser">Tutorial 总览</div>
              <!-- <div class="item-title-label">（按姓氏拼音排列）</div> -->
            </span>
          </div>
          <div class="item-content" v-show="false">
            <p class="content-null-info">敬请期待......</p>
            <!-- <p class="content-null-info">1. 大模型基础理论、结构与微调</p>
            <p class="content-null-info">2. 基于非完备数据的可信机器学习</p>
            <p class="content-null-info">3. 深度学习网络架构设计</p>
            <p class="content-null-info">4. 科学智能 (AI for Science)</p> -->
          </div>
          <div class="speaker-list" v-show="false">
            <div>
            <div style="display: flex;">
              <div class="speaker-item" v-for="item in tutorials.t1">
                
                <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}"></div>
                
                <div class="speaker-name">{{item.name}}</div>
                <div class="speaker-org">{{item.organization}}</div>
                <div style="font-weight:bolder; color:#E6A23C;">《{{item.title}}》</div>
                
              </div>
            </div>
              <div style="font-weight:bolder; color:#E6A23C;margin-top: 20px;">T1: 大模型基础理论、结构与微调</div>
            </div>

            <div>
            <div style="display: flex;">
              <div class="speaker-item" v-for="item in tutorials.t2">
                
                <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}"></div>
                
                <div class="speaker-name">{{item.name}}</div>
                <div class="speaker-org">{{item.organization}}</div>
                <div style="font-weight:bolder; color:#67C23A;">《{{item.title}}》</div>
                <!-- <div style="font-weight:bolder; color:#67C23A;">《视频生成的初探及其可控性研究》</div> -->
              </div>
            </div>
              <div style="font-weight:bolder; color:#67C23A;margin-top: 20px;">T2: 可信机器学习</div>
            </div>
            <div>
              <div style="display: flex;">
              <div class="speaker-item" v-for="item in tutorials.t3">
                <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}"></div>
                <div class="speaker-name">{{item.name}}</div>
                <div class="speaker-org">{{item.organization}}</div>
                <div style="font-weight:bolder; color:#E6A23C;">《{{item.title}}》</div>

                <!-- <div style="font-weight:bolder; color:#E6A23C;">《开放词汇视觉感知》</div> -->
              </div>
            </div>
              <div style="font-weight:bolder; color:#E6A23C;margin-top: 20px;">T3: 深度学习网络架构设计</div>
            </div>
              <div>
              <div style="display: flex;">
                <div class="speaker-item" v-for="item in tutorials.t4">
                  <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}"></div>
                  <div class="speaker-name">{{item.name}}</div>
                  <div class="speaker-org">{{item.organization}}</div>
                <div style="font-weight:bolder; color:#67C23A;">《{{item.title}}》</div>

                </div>
              </div>
              <div style="font-weight:bolder; color:#67C23A;margin-top: 20px;">T4: AI4Science</div>
            </div>
            </div>
          
          <div class="content-item" v-show="false">
            <div class="item-title">
              <span class="item-title-content">
                <div class="pc-browser">T1: 大模型基础理论、结构与微调</div>
                <div class="mobile-browser">T1: 大模型基础理论、结构与微调</div>
                <!-- <div class="item-title-label">（按姓氏拼音排列）</div> -->
              </span>
            </div>
            <div class="item-content">
              <div class="tutorial-item" v-for="item in tutorials.t1">
                <div class="tutorial-item-images" :style="{'background-image':'url('+item.image+')'}"></div>
                <div class="tutorial-item-intro"><span class="item-name">{{item.name}}</span><br/>{{item.intr}}</div>
                <div class="report-title-contain">{{item.title}}</div>
                <div class="report-abstract">{{item.content}}</div>
              </div>
            </div>
          </div>
          
          <div class="content-item" v-show="false">
            <div class="item-title">
              <span class="item-title-content">
                <div class="pc-browser">T2: 可信机器学习</div>
                <div class="mobile-browser">T2: 可信机器学习</div>
                <!-- <div class="item-title-label">（按姓氏拼音排列）</div> -->
              </span>
            </div>
            <div class="item-content">
              <div class="tutorial-item" v-for="item in tutorials.t2">
                <div class="tutorial-item-images" :style="{'background-image':'url('+item.image+')'}"></div>
                <div class="tutorial-item-intro"><span class="item-name">{{item.name}}</span><br/>{{item.intr}}</div>
                <div class="report-title-contain">{{item.title}}</div>
                <div class="report-abstract">{{item.content}}</div>
              </div>
            </div>
          </div>

          <div class="content-item" v-show="false">
            <div class="item-title">
              <span class="item-title-content">
                <div class="pc-browser">T3: 深度学习网络架构设计</div>
                <div class="mobile-browser">T3: 深度学习网络架构设计</div>
                <!-- <div class="item-title-label">（按姓氏拼音排列）</div> -->
              </span>
            </div>
            <div class="item-content">
              <div class="tutorial-item" v-for="item in tutorials.t3">
                <div class="tutorial-item-images" :style="{'background-image':'url('+item.image+')'}"></div>
                <div class="tutorial-item-intro"><span class="item-name">{{item.name}}</span><br/>{{item.intr}}</div>
                <div class="report-title-contain">{{item.title}}</div>
                <div class="report-abstract">{{item.content}}</div>
              </div>
            </div>
          </div>

          <div class="content-item" v-show="false">
            <div class="item-title">
              <span class="item-title-content">
                <div class="pc-browser">T4: AI4Science</div>
                <div class="mobile-browser">T4: AI4Science</div>
                <!-- <div class="item-title-label">（按姓氏拼音排列）</div> -->
              </span>
            </div>
            <div class="item-content">
              <div class="tutorial-item" v-for="item in tutorials.t4">
                <div class="tutorial-item-images" :style="{'background-image':'url('+item.image+')'}"></div>
                <div class="tutorial-item-intro"><span class="item-name">{{item.name}}</span><br/>{{item.intr}}</div>
                <div class="report-title-contain">{{item.title}}</div>
                <div class="report-abstract">{{item.content}}</div>
              </div>
            </div>
          </div>

        </div>
        
      </div>
      <div class="content-item-grp" v-show="true">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">Tutorial 列表</span>
          </div>
          <div class="item-content tutorial-schedule-overview">
            <!-- <p class="schedule-overview-note">以下与「大会程序」页面日程一致；同场次的 Workshop 请见 Workshop 页面。</p> -->

            <div class="item-content-title">5月9日（星期六）</div>
            <p class="parallel-hint"><span class="text-black-border">08:30-12:00</span> Tutorial（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 1：智能体AI</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：黄超（香港大学），沈永亮（浙江大学），刘卫文 (上海交通大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉旗厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 2：视觉基础模型</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：左旺孟（哈尔滨工业大学），赵恒爽（香港大学），李翔（南开大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江天厅 </div>
              </div>
            </div>

            <p class="parallel-hint"><span class="text-black-border">13:30-17:00</span> Tutorial（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 3：具身智能基础模型</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：蒋树强（中国科学院大学），李弘扬（香港大学），穆尧（上海交通大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉旗厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 4：空间智能</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：杨蛟龙（微软亚洲研究院），李崇轩（中国人民大学），彭思达（浙江大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江天厅 </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Tutorial",
      data(){
          return {
            tutorials: this.$dicts.tutorial,
          }
      }
    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/sub_banner/05.jpg");
  }
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .tutorial-item{
    /*display: flex;*/
    /*width: 100%;*/
    margin: 16px 0;
    clear: both;
    background-color: #efefef;
    padding: 8px;
    border-radius: 10px;
    min-height: 150px;
  }
  .tutorial-item .tutorial-item-images{
    width: 140px;
    height: 140px;
    margin: 12px auto;
    background-size: cover;
    background-repeat: no-repeat;
    /*background-position: center;*/
    border-radius: 90px;
    float:left;
    align:center;
    margin: 0 8px;
    /*clear: both;*/
  }
  .tutorial-item .tutorial-item-intro{
    /*width: 100%;*/
    text-align: justify;
    padding: 0 8px;
    padding-top: 40px;
    font-size: 18px;
  }
  .tutorial-item-intro .item-name{

    font-weight: 600;
  }
  .tutorial-intro{
    text-align: left;
    margin-top: -20px;
  }
  .speaker-list{
    display: flex;
    justify-content:center;
    flex-wrap:wrap;
  }
  .speaker-list .speaker-item{
    width: 200px;
    height: 240px;
  }
  .speaker-image{

    width: 140px;
    height: 140px;
    margin: 12px auto;
    background-size: cover;
    background-repeat: no-repeat;
    /*background-position: center;*/
    border-radius: 30px;
  }
  .speaker-list .speaker-name{
    color: #0053a1;
    font-weight: 500;
  }
  .text-center{
    text-align: center;
  }
  .item-title-label{
    font-size: 12px;
    color: #2c3e50;
    padding-top: -10px;
    font-weight: normal;
  }

  .report-title-contain{
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
    color: #0053a1;
    font-weight: 700;
  }
  .report-abstract{
    text-indent: 2em;
    text-align: justify;
    padding: 0 8px;
    font-size: 18px;
  }
  .speakerandpanel-contain{
    margin-left: 50px;
    font-weight: 600;
  }

  @media screen  and (max-width: 800px){
    .content-item {
      margin: 70px auto;
      margin-bottom: 30px;
    }
    .program_banner{
      /*background-image: url("../../static/images/corporate_mobile_banner.jpg");*/
      background-size: cover;
      background-position: 28% 100%;
    }
    /*.item-title-content{*/
      /*position: relative;*/
      /*top:-38px;*/
    /*}*/
    /*.item-content{*/
      /*margin-top: -30px;*/
    /*}*/
  }
  @media screen and (max-width: 410px){
    .workshop-speaker-contain{
      justify-content:center ;
    }
    .report-item-contain .report-title-contain{
      font-size: 16px;

    }
    .workshop-speaker-item .speaker-item-intro{
      white-space: pre-wrap;
      word-wrap:break-word;
    }
  }

  .tutorial-schedule-overview{
    margin-top: 16px;
    text-align: left;
    padding: 0 8px 24px;
  }
  .schedule-overview-note{
    font-size: 14px;
    color: #606266;
    margin-bottom: 16px;
    line-height: 1.5;
  }
  .item-content-title{
    font-weight: bolder;
    font-size: 18px;
    margin-bottom: 8px;
    margin-top: 24px;
    color: #0053a1;
  }
  .text-black-border{
    font-weight: bold;
  }
  .parallel-hint{
    margin: 12px 0 8px;
    font-size: 15px;
  }
  .parallel-list{
    margin-bottom: 8px;
  }
  .parallel-item{
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: #fafafa;
  }
  .parallel-name{
    font-weight: bold;
    color: #409EFF;
    margin-bottom: 6px;
  }
  .parallel-meta{
    font-size: 14px;
    line-height: 1.6;
    color: #303133;
  }

</style>



// WEBPACK FOOTER //
// src/components/Tutorial.vue